import * as React from "react"

const SvgDiscussions = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 100 85.122"
    {...props}
  >
    <path
    style={{
      fill: "rgb(185, 185, 185)",
    }}
     d="M84.933 0H15.067C6.747 0 0 7.061 0 15.771v33.692c0 8.71 6.747 15.771 15.067 15.771h11.528v18.617c0 1.027 1.412 1.751 2.143.888l16.478-19.505h39.717c8.32 0 15.067-7.061 15.067-15.771V15.771C100 7.061 93.253 0 84.933 0z" />
  </svg>
)

export default SvgDiscussions;